var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('connector-detail-v2',{attrs:{"id":_vm.id,"con_type":_vm.con_type}})}
var staticRenderFns = []

export { render, staticRenderFns }